"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSinterklaasCampaignPeriod = exports.isSinterklaasPeriod = exports.isChristmasCampaignPeriod = exports.isChristmasPeriod = exports.isCyberMonday = exports.isBlackFriday = exports.isBlackFridayPeriod = exports.EventName = void 0;
const constants_1 = require("@coolblue-development/constants");
var EventName;
(function (EventName) {
    EventName["BLACK_FRIDAY_PERIOD"] = "Black Friday period";
    EventName["BLACK_FRIDAY"] = "Black Friday";
    EventName["CYBER_MONDAY"] = "Cyber Monday";
    EventName["CHRISTMAS_PERIOD"] = "Christmas period";
    EventName["CHRISTMAS_CAMPAIGN_PERIOD"] = "Christmas campaign period";
    EventName["SINTERKLAAS_PERIOD"] = "Sinterklaas period";
    EventName["SINTERKLAAS_CAMPAIGN_PERIOD"] = "Sinterklaas campaign period";
})(EventName || (exports.EventName = EventName = {}));
const eventDates = {
    [EventName.BLACK_FRIDAY_PERIOD]: {
        start: '2025-11-10T00:00:00',
        end: '2025-12-01T23:59:59',
    },
    [EventName.BLACK_FRIDAY]: {
        start: '2025-11-28T00:00:00',
        end: '2025-11-28T23:59:59',
    },
    [EventName.CYBER_MONDAY]: {
        start: '2025-12-01T00:00:00',
        end: '2025-12-01T23:59:59',
    },
    [EventName.CHRISTMAS_PERIOD]: {
        start: '2025-12-08T00:00:00',
        end: '2025-12-24T23:59:59',
    },
    [EventName.CHRISTMAS_CAMPAIGN_PERIOD]: {
        start: {
            [constants_1.Subsidiary.NL]: '2025-12-08T00:00:00',
            [constants_1.Subsidiary.BE]: '2025-12-08T00:00:00',
            [constants_1.Subsidiary.DE]: '2025-12-02T00:00:00',
        },
        end: '2025-12-31T23:59:59',
    },
    [EventName.SINTERKLAAS_PERIOD]: {
        start: '2025-11-12T00:00:00',
        end: '2025-12-05T23:59:59',
    },
    [EventName.SINTERKLAAS_CAMPAIGN_PERIOD]: {
        start: '2025-12-01T00:00:00',
        end: '2025-12-05T23:59:59',
    },
};
const isBlackFridayPeriod = (subsidiary, now) => isActive(EventName.BLACK_FRIDAY_PERIOD, subsidiary, now);
exports.isBlackFridayPeriod = isBlackFridayPeriod;
const isBlackFriday = (subsidiary, now) => isActive(EventName.BLACK_FRIDAY, subsidiary, now);
exports.isBlackFriday = isBlackFriday;
const isCyberMonday = (subsidiary, now) => isActive(EventName.CYBER_MONDAY, subsidiary, now);
exports.isCyberMonday = isCyberMonday;
const isChristmasPeriod = (subsidiary, now) => isActive(EventName.CHRISTMAS_PERIOD, subsidiary, now);
exports.isChristmasPeriod = isChristmasPeriod;
const isChristmasCampaignPeriod = (subsidiary, now) => isActive(EventName.CHRISTMAS_CAMPAIGN_PERIOD, subsidiary, now);
exports.isChristmasCampaignPeriod = isChristmasCampaignPeriod;
const isSinterklaasPeriod = (subsidiary, now) => isActive(EventName.SINTERKLAAS_PERIOD, subsidiary, now);
exports.isSinterklaasPeriod = isSinterklaasPeriod;
const isSinterklaasCampaignPeriod = (subsidiary, now) => isActive(EventName.SINTERKLAAS_CAMPAIGN_PERIOD, subsidiary, now);
exports.isSinterklaasCampaignPeriod = isSinterklaasCampaignPeriod;
const isActive = (event, subsidiary, now) => {
    const { start, end } = eventDates[event];
    const startStr = isSubsidiaryMap(start) ? start[subsidiary] : start;
    const endStr = isSubsidiaryMap(end) ? end[subsidiary] : end;
    const currentDate = (now || new Date()).toISOString();
    const startDate = new Date(startStr).toISOString();
    const endDate = new Date(endStr).toISOString();
    return currentDate >= startDate && currentDate <= endDate;
};
const isSubsidiaryMap = (str) => {
    // noinspection SuspiciousTypeOfGuard
    return typeof str !== 'string';
};
